import { NgModule } from '@angular/core';

import { TrackErrorDirective } from './directives/track-error/track-error.directive';
import { TrackFieldfocusDirective } from './directives/track-fieldfocus/track-fieldfocus.directive';
import { TrackImpressionDirective } from './directives/track-impression/track-impression.directive';
import { TrackInteractionDirective } from './directives/track-interaction/track-interaction.directive';
import { TrackLinkDirective } from './directives/track-link/track-link.directive';
import { TrackProductDirective } from './directives/track-product/track-product.directive';
import { TrackStepDirective } from './directives/track-step/track-step.directive';
import { TrackValueChangeDirective } from './directives/track-value-change/track-value-change.directive';

// --- Migrated directives ---
// These directives are migrated to the new analytics directive setup:
// - imported via `@analytics/events`.
// - standalone directive
// - using the datalayer service in it's internals.
const migratedDirectives = [
  TrackInteractionDirective,
  TrackLinkDirective,
  TrackImpressionDirective,
  TrackProductDirective,
  TrackErrorDirective,
  TrackFieldfocusDirective,
  TrackStepDirective,
  TrackValueChangeDirective,
];

/**
 * Angular Module that exposes the analytics directives.
 *
 * @note - This Module should only be used in components that are not Standalone yet.
 * For standalone components, please import the respectful directives directly.
 */
@NgModule({
  declarations: [],
  imports: [...migratedDirectives],
  exports: [...migratedDirectives],
})
export class AnalyticsDirectivesModule {}
